import React from "react";
import { FASI_NOMI } from "@/lib/helpers";

/** Horizontal 8-step stepper matching the design mockups. */
export default function Stepper({ fasi, currentFase, compact = false }) {
  return (
    <div className="stepper w-full">
      {fasi.map((f, idx) => {
        const done = f.stato === "Completata";
        const wip = f.stato === "In lavorazione";
        const na = f.stato === "Non applicabile";
        const active = currentFase === f.num;
        const nextDone = fasi[idx + 1]?.stato === "Completata";
        return (
          <React.Fragment key={f.num}>
            <div className={`stepper-node ${active ? "active" : ""} ${done ? "done" : ""}`}>
              <div className={`stepper-circle ${done ? "done" : wip ? "wip" : na ? "na" : ""}`}>
                {done ? "✓" : f.num}
              </div>
              {!compact && <div className="stepper-label">{FASI_NOMI[f.num - 1]}</div>}
              {active && wip && !compact && <div className="text-[10px] text-amber-600 font-semibold">In lavorazione</div>}
            </div>
            {idx < fasi.length - 1 && (
              <div className={`stepper-line ${done && nextDone ? "done" : done ? "done" : ""}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
